import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import MostReadItem from '@fuww/library/src/List/MostRead';
import LinkAndAnchor from '../../LinkAndAnchor';
import { useSiteContext } from '../../SiteContext';
import getArticlesParameters from '../../../lib/getArticlesParameters';
import getCategoryTitle from '../../../lib/getCategoryTitle';
import FormattedDate from '../../FormattedDate';

const ArticleList = ({
  newsArticles,
  showCategory,
  showLoader,
}) => {
  const intl = useIntl();
  const { hasLocalNews } = useSiteContext();

  return (
    <>
      {newsArticles.map((newsArticle, index) => {
        const {
          id,
          category,
          insertedAt,
          title,
        } = newsArticle;
        return (
          <li key={id}>
            <LinkAndAnchor
              route="article"
              params={getArticlesParameters(newsArticle)}
              useRouter
            >
              <MostReadItem
                showLoader={showLoader}
                title={title}
                date={<FormattedDate value={insertedAt} />}
                number={index + 1}
                category={
                  showCategory
                  && getCategoryTitle(category, hasLocalNews, intl)
                }
              />
            </LinkAndAnchor>
          </li>
        );
      })}
    </>
  );
};

ArticleList.propTypes = {
  newsArticles: PropTypes.arrayOf(PropTypes.shape({})),
  showCategory: PropTypes.bool,
  showLoader: PropTypes.bool,
};

ArticleList.defaultProps = {
  newsArticles: [],
  showCategory: null,
  showLoader: false,
};

export default ArticleList;
